<template>
  <div id="main-box">
    <div class="page-content">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <!-- <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="PayVIP()">立即购买</button> -->
          <span class="x-right buyHistory xblock-row" v-on:click="BuyHistory('Purchased')">购买记录</span>
        </div>

        <table class="layui-table">
          <thead>
            <tr>
              <th class="table-describe">订购版本介绍</th>
              <th class="table-vip">免费版</th>
              <th class="table-vip"><i class="hidden-function" v-on:click="GetPackage(1)">付费版</i></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>可用店铺数</td>
              <td>1个</td>
              <td>店铺使用数量可以叠加，每个店铺的过期时间，根据购买时间和购买周期来决定</td>
            </tr>
            <tr>
              <td>使用期间</td>
              <td>无限期</td>
              <td>按购买周期计算</td>
            </tr>
            <tr>
              <td>上新限制</td>
              <td>10</td>
              <td>无限制</td>
            </tr>
            <tr>
              <td>图片翻译</td>
              <td>资源包</td>
              <td>资源包</td>
            </tr>
            <tr>
              <td>文字翻译</td>
              <td><i class="layui-icon">&#xe605;</i></td>
              <td><i class="layui-icon">&#xe605;</i></td>
            </tr>
            <tr>
              <td>产品采集</td>
              <td><i class="layui-icon">&#xe605;</i></td>
              <td><i class="layui-icon">&#xe605;</i></td>
            </tr>
            <tr>
              <td>图片空间</td>
              <td><i class="layui-icon">&#xe605;</i></td>
              <td><i class="layui-icon">&#xe605;</i></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <div class="pay_box" v-if="isShow">
      <div class="pay_box_main">
        <div class="pay_box_title">{{paydatas.name}}<img v-on:click="close_pay_box" class="pay_close" src="../../../static/images/close_01.png"></div>
        <div class="pay_box_img">
          <div v-if="payType == 2" id="qrimg"></div>
          <div v-else><iframe scrolling="no" frameborder=0 width="260px" height="260px" :srcdoc="qr"></iframe></div>
        </div>
        <div class="pay_box_hint">
          请使用
          <i v-if="payType == 1">支付宝</i>
          <i v-else>微信</i>
          扫描二维码进行充值
        </div>
      </div>
    </div>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var num = 1,
    TimerFun;
  var self, form, layer, laypage, VipBox, OneXml = "",count = 1, one_price = 0,
    TwoXml = "",
    ThreeXml = "",
    FourXml = "",
    FiveXml = "",
    SixXml = "",
    ShopXml = "";
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  import QRCode from 'qrcodejs2'
  export default {
    name: 'Pricing',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        item: null,
        shops:[],
        payUrl:null,
        isLoding: true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        shop_count:1,
        current_status: 0,
        status_id: 0,
        list: [],
        allshop:false,
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "打包"
        }],
        payType: 1,
        paydatas: null,
        isShow: false,
        PackageData: []
      }
    },
    beforeDestroy() {
      clearTimeout(TimerFun);
    },
    mounted() {
      self = this;
      self.SetNavActive("上架",self.$route.name);
      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //购买类型
        form.on('radio(PayData)', function(data) {
          //清除输入框内容
          self.shop_count = 1;
          $("#shop_number").val("");

          if ($('#PayData input[name="PayData"]:checked').val() == "1") {
            $(".vip-box").show();
            $(".resource-box,.spaces-box").hide();
          } else if ($('#PayData input[name="PayData"]:checked').val() == "2") {
            $(".resource-box").show();
            $(".vip-box,.spaces-box").hide();
          } else {
            $(".spaces-box").show();
            $(".vip-box,.resource-box").hide();
          }
          self.CostCalculation();
          form.render();
        });

        //店铺类型
        form.on('checkbox(shop-count)', function(data) {
          //清除输入框内容
          self.shop_count = 1;
          $("#shop_number").val("");

          var child = $(".shop-count input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();

          var str = $('.shop-count input[type=checkbox]:checked').attr("data-name");
          var count = str.replace(/[^0-9]/ig,"");
          self.shops.splice(count,self.shops.length);
          var child = $(".shops input[type='checkbox']");
          child.each(function(index, item) {
            if(index >= count){
              item.checked = false;
            }
          });

          form.render();
        });

        //购买周期
        form.on('checkbox(vip-date)', function(data) {
          var child = $(".vip-date input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();
          form.render();
        });

        //店铺选择
        form.on('checkbox(shop)', function(data) {
          var str = $('.shop-count input[type=checkbox]:checked').attr("data-name");
          var count = 1;
          if(str){
            count = str.replace(/[^0-9]/ig,"");
          }else{
            count = $("#shop_number").val();
          }

          var child = $(".shops input[type='checkbox']");
          var x = 0;
          var shop_id = data.elem.dataset.id;

          //存在移除
          if(!data.elem.checked){
            for(let i in self.shops){
              if(self.shops[i] == shop_id){
                self.shops.splice(i,1);
              }
            }
          }

          child.each(function(index, item) {
            if(item.checked){
              x++
              if(x > count){
                  layer.msg("该套餐只能选择"+count+"个店铺！");
                  data.elem.checked = false;
                  return;
              }
            }
          });

          //不存在插入
          if(data.elem.checked){
            if($.inArray(shop_id, self.shops) == -1){
              self.shops.push(shop_id);
            }
          }

          form.render('checkbox');
        });

        //资源类型
        form.on('checkbox(translate-type)', function(data) {
          var child = $(".translate-type input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();
          form.render();
        });

        //套餐次数
        form.on('checkbox(translate-count)', function(data) {
          var child = $(".translate-count input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();
          form.render();
        });

        //空间大小
        form.on('checkbox(space-size)', function(data) {
          var child = $(".space-size input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();
          form.render();
        });

        //空间时间
        form.on('checkbox(space-date)', function(data) {
          var child = $(".space-date input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          self.CostCalculation();
          form.render();
        });

        self.GetPackage();
        self.GetShopList();
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      PayVIP(state) {
        self.vip = true;
        var w, h;
        let l = $(".page-content").offset().left + 20;
        if (w == null || w == '') {
          w = $(window).width() - l - 20;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        VipBox = layer.open({
          type: 1,
          offset: '100px',
          title: "购买VIP",
          area: [w + 'px', h + 'px'],
          offset: ['75px', l+'px'],
          fixed: false, //不固定
          btn: ['支付宝支付', '微信支付'],
          skin: 'package-box',
          content: PayVIPHtml,
          success: function() {
            $(".shop-count").html(OneXml);
            $(".vip-date").html(TwoXml);
            $(".shops").html(ShopXml);
            $(".translate-type").html(ThreeXml);
            $(".translate-count").html(FourXml);
            $(".space-size").html(FiveXml);
            $(".space-date").html(SixXml);
            self.CostCalculation();

            //手动输入店铺数量
            $("#shop_number").on("input",function(e){
              let count = e.delegateTarget.value;
              self.shop_count = count;
              if(count > 1){
                var child = $(".shop-count input[type='checkbox']");
                child.each(function(index, item) {
                  item.checked = false;
                });
              }else{
                var child = $(".shop-count input[type='checkbox']")[0];
                child.checked = true;
              }

              //店铺选择
              var str = $('.shop-count input[type=checkbox]:checked').attr("data-name");
              self.shops.splice(count,self.shops.length);
              var child = $(".shops input[type='checkbox']");
              child.each(function(index, item) {
                if(index >= count){
                  item.checked = false;
                }
              });

              self.CostCalculation();
              form.render();
            });

            form.render();
          },
          yes: function(index, layero) {
            self.PackageCheck(1, "buy_package_by_ali_pay");
          },
          btn2: function(index, layero) {
            self.PackageCheck(2, "buy_package_by_wei_xin");
            return false;
          },
          end: function(){
            self.shops = [];
          }
        });
      },
      EditItem(item) {
        self.item = item;
        self.modal_box_show(self, 'Pricing', "编辑定价模板", item);
      },
      GetPackage(state) {
        self.loading = true;
        let str = "";
        if(state == 1){
          str = "?vip=1"
        }
        axios({
          method: 'get',
          url: self.GetServerUrl() + "/package_item/"+str,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if(state == 1){
              layer.msg("触发隐藏功能！");
            }

            var PackageDatas = datas.package_item;
            OneXml = "", TwoXml = "", ThreeXml = "", FourXml = "", FiveXml = "", SixXml = "";
            for (let x in PackageDatas) {
              for (let y in PackageDatas[x]) {
                for (let z in PackageDatas[x][y]) {
                  if (x == 1 && y == 1) {
                    if (z == 0) {
                      OneXml += '<input type="checkbox" lay-filter="shop-count" data-id="' + PackageDatas[x][y]
                        [z]
                        .id + '" data-name="' + PackageDatas[x][y][z].name + '" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      OneXml += '<input type="checkbox" lay-filter="shop-count" data-id="' + PackageDatas[x][y]
                        [z]
                        .id + '" data-name="' + PackageDatas[x][y][z].name + '" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  } else if (x == 1 && y == 2) {
                    if (z == 0) {
                      TwoXml += '<input type="checkbox" lay-filter="vip-date" data-id="' + PackageDatas[x][y][z]
                        .id +
                        '" data-day="'+PackageDatas[x][y][z].value+'" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      TwoXml += '<input type="checkbox" lay-filter="vip-date" data-id="' + PackageDatas[x][y][z]
                        .id +'" data-day="'+PackageDatas[x][y][z].value+'" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  } else if (x == 2 && y == 1) {
                    if (z == 0) {
                      ThreeXml += '<input type="checkbox" lay-filter="translate-type" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      ThreeXml += '<input type="checkbox" lay-filter="translate-type" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  } else if (x == 2 && y == 2) {
                    if (z == 0) {
                      FourXml += '<input type="checkbox" lay-filter="translate-count" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      FourXml += '<input type="checkbox" lay-filter="translate-count" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  } else if (x == 3 && y == 1) {
                    if (z == 0) {
                      FiveXml += '<input type="checkbox" lay-filter="space-size" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      FiveXml += '<input type="checkbox" lay-filter="space-size" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  } else if (x == 3 && y == 2) {
                    if (z == 0) {
                      SixXml += '<input type="checkbox" lay-filter="space-date" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '" checked>'
                    } else {
                      SixXml += '<input type="checkbox" lay-filter="space-date" data-id="' + PackageDatas[
                          x]
                        [y][z].id + '" title="' + PackageDatas[x][y][z].name + '">'
                    }
                  }
                }
              }
            }
            OneXml += "<input class='shop-count-input' id='shop_number' placeholder='店铺个数' />"
            self.PackageData = datas.package;
            self.list = PackageDatas;
          }, false, false);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      CostCalculation(te) {
        var idone, idtwo, nameone, nametwo, price = 0;
        if ($('#PayData input[name="PayData"]:checked').val() == "1") {
          var ShopCount = $(".shop-count input[type='checkbox']");
          var VipDate = $(".vip-date input[type='checkbox']");

          if(self.shop_count > 1){
            var list = self.list[1][1];
            for(let i in list){
              if(self.shop_count >= list[i].value){
                idone = list[i].id;
                nameone = list[i].name;
              }
            }
          }else{
            ShopCount.each(function(index, item) {
              if (item.checked) {
                idone = $(this).attr("data-id");
                nameone = $(this).attr("title");
              }
            });
          }

          VipDate.each(function(index, item) {
            if (item.checked) {
              idtwo = $(this).attr("data-id");
              nametwo = $(this).attr("title");
            }
          });
        } else if($('#PayData input[name="PayData"]:checked').val() == "2"){
          var TranslateType = $(".translate-type input[type='checkbox']");
          var TranslateCount = $(".translate-count input[type='checkbox']");
          TranslateType.each(function(index, item) {
            if (item.checked) {
              idone = $(this).attr("data-id");
              nameone = $(this).attr("title");
            }
          });
          TranslateCount.each(function(index, item) {
            if (item.checked) {
              idtwo = $(this).attr("data-id");
              nametwo = $(this).attr("title");
            }
          });
        } else {
          var SpaceSize = $(".space-size input[type='checkbox']");
          var SpaceDate = $(".space-date input[type='checkbox']");
          SpaceSize.each(function(index, item) {
            if (item.checked) {
              idone = $(this).attr("data-id");
              nameone = $(this).attr("title");
            }
          });
          SpaceDate.each(function(index, item) {
            if (item.checked) {
              idtwo = $(this).attr("data-id");
              nametwo = $(this).attr("title");
            }
          });
        }
        var ids = idone + ',' + idtwo;
        for (let i in self.PackageData) {
          if (self.PackageData[i].ids == ids) {
            price = self.PackageData[i].money;
            if(self.shop_count > 1){
              let count = self.shop_count;
              let name = nameone.substring(0,nameone.length-2);
              one_price = price/name;
              price = (price/name*count).toFixed(2);
            }
          }
        }

        //请求类型
        var name = nameone + ',' + nametwo;
        if (te == "return") {
          return {
            ids: ids,
            name: name,
            price: price
          };
        } else {

          var shop_number = $("#shop_number").val();
          if(shop_number){
            count = shop_number;
          }else{
            var str = $('.shop-count input[type=checkbox]:checked').attr("data-name");
            var count = str.replace(/[^0-9]/ig,"");
          }

          var day = $('.vip-date input[type=checkbox]:checked').attr("data-day");
          var num = 1;
          if(day/30 > 0){
            num = 　Math.floor(day/30);
          }

          var thrift = 18 * num * count - price;
          $(".layui-price,.layui-discount-price").text("￥"+price);
          if(thrift > 0){
            $(".layui-thrift-price").show().text("节省：￥"+thrift);
          }else{
            $(".layui-thrift-price").hide();
          }
        }
      },
      close_pay_box() {
        self.isShow = false;
        clearTimeout(TimerFun);
      },
      PackageCheck (te,url) {
        self.payType = te;
        self.payUrl = url;
        var str = $('.shop-count input[type=checkbox]:checked').attr("data-name");
        if(str){
          count = str.replace(/[^0-9]/ig,"");
        }else{
          count = $("#shop_number").val();
        }
        var child = $(".shops input[type='checkbox']");
        var x = 0;
        child.each(function(index, item) {
          if(item.checked){
            x++
          }
        });

        //检测是否是VIP购买
        if($('#PayData input[name="PayData"]:checked').val() == 1){
          if(x == 0){
            layer.msg("请选择套餐绑定的店铺！");
            return;
          }
          if(count > x){
            self.Confirm.txt = "当前套餐数量，大于店铺数是否确认购买？"
            self.Confirm.style = 1;
            self.Confirm.state = true;
          }else{
            self.CreatePayQr();
          }
        }else{
          self.CreatePayQr();
        }

      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.Confirm.state = false;
          self.CreatePayQr();
        }
      },
      CreatePayQr() {
        self.paydatas = self.CostCalculation("return");
        if (!self.paydatas.ids) {
          layer.msg("套餐id为空！");
          return;
        }

        let param = new URLSearchParams()

        if(self.payType == 1){
          param.append('pay_type', "ali")
        }else{
          param.append('pay_type', "wx")
        }
        // param.append('count', count)
        // param.append('price', one_price)
        param.append('ids', self.paydatas.ids)
        if(self.shops.length > 0){
          param.append('shop_ids', JSON.stringify(self.shops))
        }

        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/buy_package/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isShow = true;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            num = 1; //重置检测次数
            clearTimeout(TimerFun); //清除之前定时器
            if (self.payType == 1) {
              self.qr = datas.qr;
            } else {
              self.qrcode(datas.qr); //生成二维码
            }
            self.wx_pay_status(datas.order_id); //支付状态检测
            layer.close(VipBox);
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })

      },
      wx_pay_status(oid) {
        let param = new URLSearchParams()
        param.append('oid', oid)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/pay_status/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = false;
            layer.msg(json.msg);
            setTimeout(function(){
              location.reload();
            },1000)
          } else if (json.code == 401) {
            self.GoToPage("/"); // 路由跳转
          } else {

            //支付未完成轮巡检测
            TimerFun = setTimeout(function() {
              num++
              self.wx_pay_status(oid);
            }, 3000)
            if (num == 500) {
              clearTimeout(TimerFun)
            }

          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      qrcode(qr) {
        setTimeout(() => {
          let qrcode = new QRCode("qrimg", {
            text: qr,
            width: 260, //图像宽度
            height: 260, //图像高度
          });
          qrcode.clear(); //清除二维码
          qrcode.makeCode(qr); //生成另一个新的二维码
        }, 500);
      },
      BuyHistory (url) {
        localStorage.setItem("ExShopee_HistoryURL","Purchased");
        self.GoToPage(url);
      },
      GetShopList(ref) {
        let param = new URLSearchParams()
        param.append('num', -1)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          var json = response.data;
          if (json.code == 200) {
            var datas = json.datas.list;
            ShopXml = "";
            for(let i in datas){
              let end_time;
              if(datas[i].due_date){
                let date = new Date(datas[i].due_date);
                let now = new Date();
                if(date > now){
                  ShopXml += '<input type="checkbox" lay-filter="shop" data-id="' + datas[i].id + '" title="' + datas[i].name + '-'+datas[i].country+'(到期时间：'+datas[i].due_date+')">'
                }else{
                  ShopXml += '<input type="checkbox" lay-filter="shop" data-id="' + datas[i].id + '" title="' + datas[i].name + '-'+datas[i].country+'">'
                }
              }else{
                ShopXml += '<input type="checkbox" lay-filter="shop" data-id="' + datas[i].id + '" title="' + datas[i].name + '-'+datas[i].country+'">'
              }

            }
          }
        }).catch(function(error) {
          console.log(error);
        })

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 25px 15px;
  }

  .table-describe {
    width: 16%;
  }

  .table-vip {
    width: 32%;
  }

  .layui-icon {
    font-size: 30px;
    color: #0dc316;
  }
  .buyHistory{
    cursor: pointer;
  }
  .buyHistory:hover{
    color: #000;
  }
  .hidden-function:hover{
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Servicelimit.vue